import React from 'react';

import {
  AmountIcon,
  ChosenArea,
  ChosenButton,
  ChosenLine,
  Content,
  MatchIcon,
  Modal,
  ModalSearch,
  MoneyIcon,
  PinIcon,
  SearchArea,
  SearchOption,
  SearchRow,
  VacancieAmount,
  VacancieCategory,
  VacancieInfoRow,
  VacancieInfoSvgRow,
  VacancieLocality,
  VacancieMatchs,
  VacancieName,
  VacancieNumber,
  VacancieSalary,
  VacanciesCard,
} from './styles';

import CardUserJob from '../../cards/user-job';
import Search from '../../search';

import { toast } from 'react-toastify';
import { MatchCRUD } from 'services/requests/matchs';
import { VancancieCRUD } from 'services/requests/vancacies';
import { VancacieData } from 'services/requests/vancacies/index.d';
import { PersonalClientCRUD } from 'services/requests/personal-client';
import { PersonalClientData } from 'services/requests/personal-client/index.d';
import { useAppSelector } from 'hooks/useRedux';

import typ from './index.d';

const matchCRUD = new MatchCRUD();
const vancacieCRUD = new VancancieCRUD();
const personalClientCRUD = new PersonalClientCRUD();

const MatchModal: React.FC<typ.Props> = ({
  onClose,
  onDelete,
  onAccept,
  match,
  personalClientId,
  vacancyId,
}) => {
  // Redux
  const user = useAppSelector(({ state }) => state.user);

  // States
  const [currentMatch, setMatch] = React.useState(match);

  const [clientSearch, setClientSearch] = React.useState('');
  const [clientsOptions, setClientsOptions] = React.useState<PersonalClientData[]>();
  const [loadingSearchClients, setLoadingSearchClients] = React.useState(false);

  const [vacancySearch, setVacancySearch] = React.useState('');
  const [vacancysOptions, setVacancysOptions] = React.useState<VancacieData[]>();
  const [loadingSearchVacancy, setLoadingSearchVacancy] = React.useState(false);

  const [warning, setWarning] = React.useState({
    searchClient: false,
    searchVacancy: false,
  });

  const [currentVacancy, setCurrentVacancy] = React.useState<VancacieData>();
  const [vacancyLoading, setVacancyLoading] = React.useState(!match);

  const [currentPersonalClient, setCurrentPersonalClient] =
    React.useState<PersonalClientData>();
  const [personalClientLoading, setPersonalClientLoading] =
    React.useState(!match);

  const getVacancy = React.useCallback(async (vacancyName?: string) => {
    try {
      if(vacancyName) setLoadingSearchVacancy(true)
      setVacancyLoading(true);
      const { data, status, error } = await vancacieCRUD.read({
        id: currentMatch?.vacancy_id.toString() || vacancyId?.toString(),
        name: vacancyName,
      });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        if(currentMatch || vacancyId) {
          setCurrentVacancy(data.Vacancy[0]);
          return;
        }
        setVacancysOptions(data.Vacancy);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingSearchVacancy(false)
    }
  }, [currentMatch]);

  const getPersonalClient = React.useCallback(async (clientName?: string) => {
    try {
      if(clientName) setLoadingSearchClients(true)
      setPersonalClientLoading(true);
      const { data, status, error } = await personalClientCRUD.modalView({
        id: currentMatch?.personal_client_relation.id || personalClientId || 0,
        name: clientName,
      });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        if(currentMatch || personalClientId) {
          setCurrentPersonalClient(data.PersonalClient[0]);
          return
        }
        setClientsOptions(data.PersonalClient)
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoadingSearchClients(false)
    }
  }, [currentMatch]);

  const handleCreate = React.useCallback(
    async (v: VancacieData | undefined, p: PersonalClientData | undefined) => {
      try {
        if (!v) {
          toast('Pesquise uma vaga!');
          return;
        }
        if (!p) {
          toast('Pesquise um cliente!');
          return;
        }

        const { data, status, error } = await matchCRUD.create({
          vacancy_id: Number(v?.id),
          advisor_id: Number(user?.id),
          personal_client_id: Number(p?.id),
        });

        if (error) {
          throw new Error(error.message.description);
        }

        if (status === 200 && data) {
          toast(`O match foi criado!`);
          handleOnClose();
        }
      } catch (e) {
        // alert(e);
      }
    },
    [],
  );

  const handleOnClose = React.useCallback(() => {
    setCurrentPersonalClient(undefined);
    setCurrentVacancy(undefined);
    setMatch(undefined);
    onClose();
  }, []);


  React.useEffect(() => {
    if (currentMatch) {
      getVacancy();
      getPersonalClient();
      return;
    }

    if(personalClientId) {
      getPersonalClient();
      return
    }

    if(vacancyId) {
      getVacancy();
    }
  }, []);

  React.useEffect(() => {
    if (vacancySearch) getVacancy(vacancySearch);
  }, [vacancySearch]);

  React.useEffect(() => {
    if (clientSearch) getPersonalClient(clientSearch);
  }, [clientSearch]);


  return (
    <Modal
      modalTitle={`${currentMatch ? 'Criar Match' : 'Match'}`}
      onClose={handleOnClose}
      hideButton
      maxWidth={981}
      buttonCallback={() => {
        null;
      }}>
      {!currentMatch && (
        <SearchArea type={personalClientId ? 'personal-client' : vacancyId ? 'vacancy': 'default'}>
          {!personalClientId && (
            <SearchRow>
              <Search
                placeholder="Pesquisar cliente"
                value={clientSearch}
                setValue={setClientSearch}
                customStyle={{ maxWidth: 294, backgroundColor: '#E4E4E4' }}
                isLoading={loadingSearchClients}
              />
              {clientSearch && (
                <ModalSearch>
                  {clientsOptions?.length === 0
                    ?
                      <SearchOption>Nenhum cliente encontrado...</SearchOption>
                    :
                      <>
                        {clientsOptions?.map((e, i) => (
                          <SearchOption key={i} onClick={() => {
                            setClientSearch('')
                            setClientsOptions(undefined)
                            setCurrentPersonalClient(e)
                          }}>{e.name}</SearchOption>
                        ))}
                      </>
                  }
                </ModalSearch>
              )}
            </SearchRow>
          )}

          {!vacancyId && (
            <SearchRow>
              <Search
                placeholder="Pesquisar Vaga"
                value={vacancySearch}
                setValue={setVacancySearch}
                customStyle={{ maxWidth: 339, backgroundColor: '#E4E4E4' }}
                isLoading={loadingSearchVacancy}
              />
              {vacancySearch && (
                <ModalSearch>
                  {vacancysOptions?.length === 0
                    ?
                      <SearchOption>Nenhum cliente encontrado...</SearchOption>
                    :
                      <>
                        {vacancysOptions?.map((e, i) => (
                          <SearchOption key={i} onClick={() => {
                          setVacancySearch('')
                          setVacancysOptions(undefined)
                          setCurrentVacancy(e)
                          }}>{e.name}</SearchOption>
                        ))}
                      </>
                  }
                </ModalSearch>
              )}
            </SearchRow>
          )}
        </SearchArea>
      )}
      <Content>
        <CardUserJob
          isAlternative
          customStyle={{ margin: 0 }}
          client={currentPersonalClient}
        />
        
        <ChosenArea>
          <ChosenLine />
          {!currentMatch ? (
            <ChosenButton
              accept
              onClick={() =>
                handleCreate(currentVacancy, currentPersonalClient)
              }>
              Criar
            </ChosenButton>
          ) : (
            <>
              <ChosenButton onClick={onDelete}>Negar</ChosenButton>
              <ChosenLine />
              <ChosenButton accept onClick={onAccept}>Aceitar</ChosenButton>
            </>
          )}
          <ChosenLine />
        </ChosenArea>

        <VacanciesCard onClick={() => null}>
          <VacancieNumber>Código da vaga: {currentVacancy?.id}</VacancieNumber>
          <VacancieInfoRow>
            <VacancieName>{currentVacancy?.name}</VacancieName>
            <VacancieInfoSvgRow>
              <MatchIcon />
              <VacancieMatchs>matchs</VacancieMatchs>
            </VacancieInfoSvgRow>
          </VacancieInfoRow>
          <VacancieCategory>{currentVacancy?.occupation}</VacancieCategory>
          <VacancieInfoSvgRow style={{ marginBottom: 25 }}>
            <AmountIcon />
            <VacancieAmount>
              {currentVacancy?.quantity}
              {` vaga ${(currentVacancy?.quantity && currentVacancy?.quantity  > 1) ? 's' : ''}`}
            </VacancieAmount>
          </VacancieInfoSvgRow>
          <VacancieInfoRow>
            <VacancieInfoSvgRow>
              <MoneyIcon />
              <VacancieSalary>
                R$
                {currentVacancy?.budget}
              </VacancieSalary>
            </VacancieInfoSvgRow>
            {currentVacancy?.workplace && (
              <VacancieInfoSvgRow>
                <PinIcon />
                <VacancieLocality>{currentVacancy?.workplace}</VacancieLocality>
              </VacancieInfoSvgRow>
            )}
          </VacancieInfoRow>
        </VacanciesCard>
      </Content>
    </Modal>
  );
};

export default MatchModal;